import { useCustomMutation, useCustomQuery } from '@gripp/shared-logic';

const CREATE_SHARE_LINK = `
  mutation CreateShareLink($subjectType: ShareSubjectType!, $subjectId: ID!) {
    share {
      createShareLink(subjectType: $subjectType, subjectId: $subjectId) {
        token
        expiresAt
      }
    }
  }
`;

export const useCreateIssueShareLink = () =>
  useCustomMutation({ query: CREATE_SHARE_LINK });

const RESOLVE_SHARE_LINK = `
  query ResolveShareLink($token: String!) {
    share {
      resolveShareLink(token: $token) {
        subjectType
        subjectId
        sharedBy {
          id
          name {
            first
            last
          }
        }
      }
    }
  }
`;

export const useResolveShareLink = (token?: string) =>
  useCustomQuery({
    query: RESOLVE_SHARE_LINK,
    variables: { token },
    cacheKey: ['share', 'resolveShareLink', token],
    options: { enabled: !!token },
  });
